module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_a/main_sp_6fe0e3d816645f7f25e4cd6522b1b918.jpg";